let user = JSON.parse(localStorage.getItem('user'));
let userInfo = JSON.parse(localStorage.getItem('userInfo'));
userInfo = userInfo ? userInfo : {};

const initialState = user ? {
    loggedIn: true,
    user,
    userInfo: userInfo,
    userInfoFresh: false,
   
} :
{
    loggedIn: false,
    userInfo: userInfo,
    userInfoFresh: false,
};

export function userReducer(state = initialState, action) {
    switch (action.type) {
        case "IS_WORKING":
            return {
                ...state,
                working: true,
               
            }
        case "FINISHED_WORKING":
            return {
                ...state,
                working: false,

            }
        case "USER_LOGGED_IN":
            return {
                working: false,
                loggedIn: true,
                user: action.user,
                type: 'alert-success',
                message: '',
                userInfo: {},
                userInfoFresh: false,
              
            }
        case "LOGIN_FAILED":
            return {
                working: false,
                loggedIn: false,
                user: {},
                type: 'alert-danger',
                message: action.payload,
                userInfo: {},
                userInfoFresh: false,
            }
        case "USER_INFO":
            return {
                ...state, 
                userInfo: action.userInfo,
                userInfoFresh: true,
            }
        case "PICTURE_INFO":
            return {
                ...state,
                userInfo: { ...state.userInfo, ...action.pictureInfo }

            }
        case "LOGOUT":
            return {
                loggedIn: false,
                userInfo: {},
                userInfoFresh: false,
            };
         default:
            return state
    }
}